import React, { useContext, useState } from 'react';
import { RiArrowDownSLine, RiArrowRightSLine } from 'react-icons/ri';
import { splitByCharacter } from 'utils/stringUtils';

const NWSAlert = ({ alert }) => {
  const [maximized, setMaximized] = useState(false);
  const titleFontSize = 'clamp(0.9rem, var(--widget-header-font-size, 0.95rem), 1.1rem)';
  const bodyFontSize = 'clamp(0.75rem, var(--widget-subtext-font-size, 0.8rem), 0.95rem)';

  return (
    <div className="d-flex bg-primary m-2 mt-2 rounded-2">
      <div className="m-2 w-100 p-1" style={{ minWidth: 0 }}>
        <div
          className="cursor-pointer fw-bold rounded-3 d-flex justify-content-between align-items-start gap-2"
          style={{ fontSize: titleFontSize, lineHeight: 1.2, minWidth: 0 }}
          onClick={() => {
            setMaximized(!maximized);
          }}
        >
          <div style={{ flex: '1 1 auto', minWidth: 0, wordBreak: 'break-word' }}>
            {`${alert.type} - ${alert.sender} `}
          </div>
          <div
            className="d-flex align-items-center gap-1"
            style={{ flex: '0 0 auto', whiteSpace: 'nowrap', fontSize: bodyFontSize }}
          >
            {alert.sentTime}
            {maximized ? <RiArrowDownSLine size={20} /> : <RiArrowRightSLine size={20} />}
          </div>
        </div>
        {maximized && (
          <div className="d-flex flex-column bg-primary m-2 rounded-2">
            <div
              className="d-flex flex-row flex-wrap h-100 align-items-center justify-content-between gap-2 border-top border-light-subtle"
              style={{ fontSize: bodyFontSize }}
            >
              <div className="mt-2">Valid Until: {alert.endTime}</div>
              <div className="mt-2">Issuing Time: {alert.startTime}</div>
            </div>

            <div
              className="mt-3 ms-2 mb-2 fw-bold flex-column justify-content-start align-self-start"
              style={{ fontSize: bodyFontSize, lineHeight: 1.25, paddingLeft: 4 }}
            >
              {/* {alert.description} */}
              {splitByCharacter(alert.description, '*').map((line, index) => {
                if (line.trim() !== '')
                  return (
                    <li key={index} style={{ marginBottom: 6 }}>
                      {line}
                    </li>
                  );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NWSAlert;
